import { create } from 'zustand';

const AUTH_KEY = 'Pulsalink-Admin-Auth';
const AUTH_KEY_TOKEN = 'Pulsalink-Admin-Auth-Key';
const AUTH_KEY_USER = 'Pulsalink-Admin-Auth-User';
const AUTH_KEY_REASON = 'Pulsalink-Admin-Auth-Reason';

const clearCookies = () => {
  const domains = [''];
  const hostnameParts = window.location.hostname.split('.');
  for (let index = 0; index < hostnameParts.length; index += 1) {
    const domain = hostnameParts.slice(index).join('.');
    domains.push(domain, `.${domain}`);
  }

  const paths = new Set(['/']);
  const pathParts = window.location.pathname.split('/');
  for (let index = 1; index <= pathParts.length; index += 1) {
    const path = pathParts.slice(0, index).join('/') || '/';
    paths.add(path);
    paths.add(path.endsWith('/') ? path : `${path}/`);
  }

  for (const cookie of document.cookie.split(';')) {
    const name = cookie.split('=')[0].trim();
    if (!name) continue;
    for (const domain of domains) {
      for (const path of paths) {
        document.cookie = `${name}=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${path}${domain ? `; domain=${domain}` : ''}`;
      }
    }
  }
};

const readAuthFromStorage = () => {
  try {
    const auth = localStorage.getItem(AUTH_KEY);
    const token = localStorage.getItem(AUTH_KEY_TOKEN);
    const userRaw = localStorage.getItem(AUTH_KEY_USER);

    if (auth != null && token != null && userRaw != null) {
      return { auth: true, token, user: JSON.parse(userRaw) };
    }
  } catch {
    // corrupted storage falls through to logged-out state
  }

  return { auth: false, token: '', user: null };
};

const useAuthStore = create((set) => ({
  ...readAuthFromStorage(),

  authInit: (auth, token, user) => set({ auth, token, user }),

  authSet: (token, user) => {
    localStorage.setItem(AUTH_KEY, true);
    localStorage.setItem(AUTH_KEY_TOKEN, token);
    localStorage.setItem(AUTH_KEY_USER, JSON.stringify(user));

    set({ auth: true, token, user });
  },

  authClear: (reason = 'manual') => {
    localStorage.clear();
    sessionStorage.clear();
    clearCookies();

    if (reason && reason !== 'manual') {
      sessionStorage.setItem(AUTH_KEY_REASON, reason);
    }

    setTimeout(() => {
      window.location.replace('/user/login');
    }, 500);

    set({ auth: false, token: '', user: null });
  },
}));

export default useAuthStore;
